module.exports = __webpack_public_path__ + "static/media/paintbrush.28fe1320.svg";